<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="card" [class.card--active]="inFocus()" data-register-focus>
  @if (currentImage()) {
    <div class="card__img-container">
      <img
        #img
        class="card-img-top"
        [id]="imageId"
        [ngSrc]="currentImage()"
        [alt]="alt()"
        [height]="300"
        [width]="100"
        priority
      />
      @if ((isImageLoading$ | async) === true) {
        <div class="card__loading-spinner">
          <app-spinner />
        </div>
      }
      <a
        class="card__img-link card__title-link fs-5"
        [routerLink]="link()"
        [attr.aria-label]="text()"
      >
        {{ text() }}
      </a>

      <button
        class="card__img-close-btn"
        btn
        [kind]="'NONE'"
        [icon]="inFocus() ? 'xmark' : 'expand'"
        [attr.aria-label]="'Expand image view of ' + text()"
        (clicked)="
          inFocus()
            ? closeBtnClicked$.next($event)
            : openBtnClicked$.next($event)
        "
        data-ignore-click="true"
      ></button>
    </div>
  }
  <div class="card-body">
    @if (imageUrls().length > 1) {
      <ul class="card__img-selectors">
        @for (_ of imageUrls(); track $index) {
          <li>
            @let imageIndex = $index + 1;
            @let isActiveButton = $index === currentImageIndex();
            <button
              class="card__img-selector"
              [class.card__img-selector--active]="isActiveButton"
              [attr.aria-label]="'Show image ' + imageIndex + ' of ' + text()"
              [attr.aria-controls]="imageId"
              [attr.aria-current]="isActiveButton ? 'true' : null"
              (click)="selectorClicked$.next({ index: $index, event: $event })"
            >
              {{ imageIndex }}
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>
